import {
  AiBlockDataLabelType,
  AiBlockMetaDataSource,
  AiBlockMetaDataType,
  AiBlockTraitType,
  AiBlockType,
} from '@prisma/client';

export type { AiBlock, AiBlockData, AiBlockMetaData, AiBlockTrait } from '@prisma/client';

export { AiBlockDataLabelType, AiBlockMetaDataSource, AiBlockMetaDataType, AiBlockTraitType, AiBlockType };

export enum UpsertLabelMode {
  Create = 'create',
  Update = 'update',
}
export interface UpsertLabelInternalOptions {
  aiBlockType?: AiBlockType;
  selectedNodeId: string;
  mode: UpsertLabelMode;
}

export interface DeleteLabelInternalOptions {
  name: string;
  selectedNodeId: string;
  aiBlockType: AiBlockType;
}
